import createIcon from '../../createIcon';

/**
 * @component @name Tungsten
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMgMTguNUgxMVYyMS41SDEzVjE4LjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNNSAxMC41SDJWMTIuNUg1VjEwLjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjIgMTAuNUgxOVYxMi41SDIyVjEwLjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTcuMzAxMiAxNS44OTQzTDE1Ljg5NDEgMTcuMzAxNEwxOC4wMTU0IDE5LjQyMjdMMTkuNDIyNSAxOC4wMTU2TDE3LjMwMTIgMTUuODk0M1oiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik02LjcwNTQ3IDE1Ljg4NzJMNC41ODQxNyAxOC4wMDg1TDUuOTkxMyAxOS40MTU2TDguMTEyNiAxNy4yOTQzTDYuNzA1NDcgMTUuODg3MloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNSA3LjUyVjIuNUg5VjcuNTJDNy43OSA4LjQ0IDcgOS44NyA3IDExLjVDNyAxNC4yNiA5LjI0IDE2LjUgMTIgMTYuNUMxNC43NiAxNi41IDE3IDE0LjI2IDE3IDExLjVDMTcgOS44NyAxNi4yMSA4LjQ0IDE1IDcuNTJaTTExIDQuNUgxM1Y2LjZDMTIuNjggNi41NCAxMi4zNCA2LjUgMTIgNi41QzExLjY2IDYuNSAxMS4zMiA2LjU0IDExIDYuNlY0LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Tungsten = createIcon('Tungsten', [
  ['path', { d: 'M13 18.5H11V21.5H13V18.5Z', key: 'hyqruz' }],
  ['path', { d: 'M5 10.5H2V12.5H5V10.5Z', key: '174cvq' }],
  ['path', { d: 'M22 10.5H19V12.5H22V10.5Z', key: '1h14tp' }],
  [
    'path',
    {
      d: 'M17.3012 15.8943L15.8941 17.3014L18.0154 19.4227L19.4225 18.0156L17.3012 15.8943Z',
      key: '2rm96b',
    },
  ],
  [
    'path',
    {
      d: 'M6.70547 15.8872L4.58417 18.0085L5.9913 19.4156L8.1126 17.2943L6.70547 15.8872Z',
      key: '1l0bln',
    },
  ],
  [
    'path',
    {
      d: 'M15 7.52V2.5H9V7.52C7.79 8.44 7 9.87 7 11.5C7 14.26 9.24 16.5 12 16.5C14.76 16.5 17 14.26 17 11.5C17 9.87 16.21 8.44 15 7.52ZM11 4.5H13V6.6C12.68 6.54 12.34 6.5 12 6.5C11.66 6.5 11.32 6.54 11 6.6V4.5Z',
      key: '1wsauj',
    },
  ],
]);

export default Tungsten;
